import React, { Component } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { changeColorOpacity, ifNavAllowed, } from '../../helpers/general_helpers';
import { NavLink, Outlet } from 'react-router-dom';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingColumns, faChartBar, faClipboardQuestion, faDashboard, faEnvelopesBulk, faFilePen, faGears, faHandshake, faPaperPlane, faPersonWalkingArrowLoopLeft, faPersonWalkingArrowRight, faReceipt, faRectangleList, faUserCheck, } from '@fortawesome/free-solid-svg-icons';

class CRMNav extends Component {
  state = {
    nav: [
      {
        id: 'crm-dashboard',
        name: 'Dashboard',
        path: '/crm/dashboard',
        icon: faDashboard,
      },
      {
        id: 'waiting',
        name: 'Leads',
        path: '/crm/waiting',
        icon: faHandshake,
      },
      {
        id: 'center-email-templates',
        name: 'Center Email Templates',
        path: '/crm/center-email-templates',
        icon: faEnvelopesBulk,
      },
      {
        id: 'referrals',
        name: 'Referrals',
        path: '/crm/referrals',
        icon: faPersonWalkingArrowLoopLeft,
      },
      {
        id: 'visitby',
        name: 'Communication Source',
        path: '/crm/visitby',
        icon: faPaperPlane,
      },
      // {
      //   id: 'followuptype',
      //   name: 'Follow Up',
      //   path: '<FollowUp />',
      //   icon: faPersonWalkingArrowRight,
      // },
      {
        id: 'noenrolment',
        name: 'No Enrollment Reasons',
        path: '/crm/noenrolment',
        icon: faFilePen,
      },
      {
        id: 'admission-qna',
        name: 'Admission Q&A',
        path: '/crm/admission-qna',
        icon: faClipboardQuestion,
      },
      {
        id: 'admission-form-attachments',
        name: 'Admission Form Attachments',
        path: '/crm/admission-form-attachments',
        icon: faRectangleList,
      },
      {
        id: 'admission-setup',
        name: 'Admission Setup',
        path: '/crm/admission-setup',
        icon: faGears,
      },
    ],
  };

  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header
              lite={true}
              heading={t('CRM')}
              backBtn
              showCenterSelector={true}
            />
            <div style={{ display: 'flex' }}>
              <div
                className='inner-blue-bar'
                style={{
                  backgroundColor: changeColorOpacity(
                    brand_colors[this.props.defaultTheme.theme_id].sidebar_bg,
                    0.15
                  ),
                  marginRight: dir == 1 ? 0 : 7,
                  marginLeft: dir == 0 ? 0 : 7,
                  minWidth: 100,
                  maxWidth: 100,
                }}>
                <ul>
                  {this.state.nav.map((item, index) => {
                    if (ifNavAllowed(item.id)) {
                      return (
                        <li key={index}>
                          <NavLink activeclassname='active' to={`${item.path}`}>
                            <FontAwesomeIcon icon={item.icon} />
                            <div>{t(item.name)}</div>
                          </NavLink>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
              <div
                style={{
                  height: 'calc(100vh - 135px)',
                  overflowY: 'auto',
                  flex: 1,
                }}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(CRMNav);
